/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_ListCommitteeAssessorUsersRow } from '../models/db_ListCommitteeAssessorUsersRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommitteeAssessorUsers {
    /**
     * Get a list of committee assessor users
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListCommitteeAssessorUsersRow OK
     * @throws ApiError
     */
    public static listCommitteeAssessorUsers(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListCommitteeAssessorUsersRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committee-assessor-users',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
